import React, { useState } from 'react';
import { createAcademyParticipant } from '../../../services/academyAdminWriteService';

const initialForm = {
  firstName: '',
  lastName: '',
  email: '',
  organizationId: '',
  status: 'active'
};

export function AcademyParticipantForm({
  organizations,
  role,
  organizationId,
  onClose,
  onCreated
}) {
  const [form, setForm] = useState({
    ...initialForm,
    organizationId: role === 'COMPANY_ADMIN' ? organizationId || '' : ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const update = (event) => {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    try {
      const result = await createAcademyParticipant(form);
      await onCreated(result.id);
      onClose();
    } catch (failure) {
      setError(failure.message || 'Deltakeren kunne ikke registreres.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="new-participant-title"
        className="max-h-[95vh] w-full max-w-xl overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl"
      >
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <h2 id="new-participant-title" className="text-xl font-semibold text-slate-900">
              Ny kursdeltaker
            </h2>
            <p className="mt-1 text-sm text-slate-600">
              Registreres uten å koble til en plattformbruker.
            </p>
          </div>
          <button type="button" onClick={onClose} className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-600">
            Lukk
          </button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <label className="block text-sm font-semibold text-slate-700">
            Fornavn
            <input
              name="firstName"
              value={form.firstName}
              onChange={update}
              required
              autoComplete="given-name"
              className="mt-2 w-full rounded-xl border border-slate-200 px-3 py-2.5 font-normal"
            />
          </label>
          <label className="block text-sm font-semibold text-slate-700">
            Etternavn
            <input
              name="lastName"
              value={form.lastName}
              onChange={update}
              required
              autoComplete="family-name"
              className="mt-2 w-full rounded-xl border border-slate-200 px-3 py-2.5 font-normal"
            />
          </label>
          <label className="block text-sm font-semibold text-slate-700">
            E-postadresse
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={update}
              required
              autoComplete="email"
              className="mt-2 w-full rounded-xl border border-slate-200 px-3 py-2.5 font-normal"
            />
          </label>

          <label className="block text-sm font-semibold text-slate-700">
            Organisasjon
            {role === 'SUPERADMIN' ? (
              <select
                name="organizationId"
                value={form.organizationId}
                onChange={update}
                className="mt-2 w-full rounded-xl border border-slate-200 px-3 py-2.5 font-normal"
              >
                <option value="">Global deltaker</option>
                {organizations.map((organization) => (
                  <option key={organization.id} value={organization.id}>{organization.name}</option>
                ))}
              </select>
            ) : (
              <input
                value={organizations.find((item) => item.id === organizationId)?.name || 'Egen organisasjon'}
                disabled
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 font-normal"
              />
            )}
          </label>
          {role === 'SUPERADMIN' && (
            <p className="-mt-2 text-xs text-slate-500">
              Organisasjonsvalgene følger det som er synlig gjennom eksisterende databasepolicyer.
            </p>
          )}

          <label className="block text-sm font-semibold text-slate-700">
            Status
            <select
              name="status"
              value={form.status}
              onChange={update}
              className="mt-2 w-full rounded-xl border border-slate-200 px-3 py-2.5 font-normal"
            >
              <option value="active">Aktiv</option>
              <option value="inactive">Inaktiv</option>
              <option value="archived">Arkivert</option>
            </select>
          </label>

          {error && <p role="alert" className="rounded-lg bg-rose-50 p-3 text-sm text-rose-700">{error}</p>}
          <div className="flex justify-end gap-3 border-t border-slate-100 pt-4">
            <button type="button" onClick={onClose} className="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700">
              Avbryt
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded-xl bg-blue-700 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-800 disabled:cursor-wait disabled:opacity-60"
            >
              {saving ? 'Lagrer …' : 'Registrer deltaker'}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}